import './footer.css';

const footerLinks = [
  {
    href: 'https://enhance-onehealth.eu/contact/',
    label: 'Contact page',
  },
  {
    href: '#',
    label: 'Terms of use',
  },
  {
    href: '#',
    label: 'Cookie policy',
  },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <a className="footer__brand" href="https://enhance-onehealth.eu/" target="_blank" rel="noopener noreferrer">
          <img alt="ENHANCE" className="footer__brand-logo" src="/img/logo/Enhance_light_monochrome_logo.png" />
        </a>
        <div className="footer__funding">
          <div className="footer__funding-logos">
            <img alt="Funded by the European Union" className="footer__funding-logo footer__funding-logo--eu" src="/img/logo/EN_FundedbytheEU_RGB_WHITE.png" />
            <img alt="EUSPA" className="footer__funding-logo footer__funding-logo--euspa" src="/img/logo/LOGO_EUSPA_horizontal_white_quadri_300 ppi.png" />
          </div>
        </div>
        <nav aria-label="Footer links" className="footer__nav">
          {footerLinks.map(link => (
            <a
              className="footer__link"
              href={link.href}
              key={link.label}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
